module.exports = __webpack_public_path__ + "img/logo.30a13369.svg";